<app-rules-error-coverage
  [customerIndex]="customerIndex()"
  [coverageIndex]="coverageIndex()"
  [errors]="alertBannerErrors"/>

<form [formGroup]="form">
  @if (sharedPolicyData) {
    <div class="grid-container">
      <!-- First row -->
      <div class="column">
        <div
          cbInput="#premium"
          label="Current Premium"
          styleVariant="gray-fill"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'premium')"
          errorMessage="Error: Premium amount">
          <input
            placeholder="Placeholder"
            type="text"
            pattern=".*"
            maxLength="50"
            [required]="false"
            [disabled]="true"
            [readOnly]="true"
            formControlName="premium" />
        </div>
        @if (coverage().premium?.amount !== coverage().premiumOriginal) {
          <div>
            <p>Original premium: ${{ coverage().premiumOriginal! / 100 | number: '1.2-2' }}</p>
          </div>
        }
      </div>
      <div class="column">
        <!-- Empty column if needed, or add content -->
      </div>
      <div class="full-width-row">
        <hr />
      </div>
      <!-- Second row -->
      <div class="column">
        <div
          [cbSelectChoice]="selectChoice"
          label="Premium Review Period"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [readonly]="true"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'premiumReviewPeriod')"
          [errorMessage]="
            hasErrorForCoverage(customerIndex(), coverageIndex(), 'premiumReviewPeriod')
              ? 'Error: Premium review period'
              : ''
          ">
          <p-select
            #selectChoice
            [options]="getRefDS('premiumReviewPeriod')"
            optionLabel="name"
            optionValue="code"
            placeholder="-"
            inputId="#premiumReviewPeriod"
            formControlName="premiumReviewPeriod"/>
        </div>
      </div>
      <div class="column">
        <div
          [cbSelectChoice]="selectChoice"
          label="Cover Term"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [readonly]="true"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'coverTerm')"
          [errorMessage]="
            hasErrorForCoverage(customerIndex(), coverageIndex(), 'coverTerm') ? 'Error: Cover term' : ''
          ">
          <p-select
            #selectChoice
            [options]="getRefDSByCoverageCode('uPremium', 'coverTerm')"
            optionLabel="name"
            optionValue="code"
            placeholder="-"
            inputId="#coverTerm"
            formControlName="coverTerm"/>
        </div>
      </div>
      <div class="column">
        <div
          [cbSelectChoice]="selectChoice"
          label="Payment Term"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [readonly]="true"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'paymentTerm')"
          [errorMessage]="
            hasErrorForCoverage(customerIndex(), coverageIndex(), 'paymentTerm') ? 'Error: Payment term' : ''
          ">
          <p-select
            #selectChoice
            [options]="getRefDSByCoverageCode('uPremium', 'paymentTerm')"
            optionLabel="name"
            optionValue="code"
            placeholder="-"
            inputId="#paymentTerm"
            formControlName="paymentTerm"/>
        </div>
      </div>
      <!-- Third row -->
      <div class="column">
        <div
          [cbSelectChoice]="selectChoice"
          label="Wait Period"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [readonly]="true"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'waitPeriod')"
          [errorMessage]="
            hasErrorForCoverage(customerIndex(), coverageIndex(), 'waitPeriod') ? 'Error: Wait period' : ''
          ">
          <p-select
            #selectChoice
            [options]="getRefDS('waitPeriod')"
            optionLabel="name"
            optionValue="code"
            placeholder="-"
            inputId="#waitPeriod"
            formControlName="waitPeriod"/>
        </div>
      </div>
      <div class="column">
        <div
          [cbSelectChoice]="selectChoice"
          label="Smoker?"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [readonly]="true"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'smoker')"
          [errorMessage]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'smoker') ? 'Error: Smoker' : ''">
          <p-select
            #selectChoice
            [options]="getRefDS('smoker')"
            optionLabel="name"
            optionValue="code"
            placeholder="-"
            inputId="#smoker"
            formControlName="smoker"/>
        </div>
      </div>
      <div class="column">
        <div
          [cbSelectChoice]="selectChoice"
          label="Occupation Class"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [readonly]="true"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'occupation.class')"
          [errorMessage]="
            hasErrorForCoverage(customerIndex(), coverageIndex(), 'occupation.class') ? 'Error: occupation class' : ''
          ">
          <p-select
            #selectChoice
            [options]="getRefDS('occupationClass')"
            optionLabel="name"
            optionValue="code"
            placeholder="-"
            inputId="#occupationClass"
            formControlName="occupationClass"/>
        </div>
      </div>
      <!-- Forth row -->
      <div class="column">
        <div class="toggle-row">
          <app-underwriting-terms
            [customerIndex]="customerIndex()"
            [coverageIndex]="coverageIndex()"
            [coverage]="coverage()"/>
        </div>
      </div>
      <div class="column">
        <!-- Empty column if needed, or add content -->
      </div>
      <div class="column">
        <!-- Empty column if needed, or add content -->
      </div>
    </div>
  }

  <div class="full-width-row">
    <app-remove-cover
      [customerIndex]="customerIndex()"
      [coverageIndex]="coverageIndex()"
      [coverage]="coverage()"/>
  </div>
</form>
